module.exports = __webpack_public_path__ + "static/media/search-tick.1d4f3022.svg";